import CowmedChip from '#/components/Chip'
import Colors from '#/styles/Colors'

type StatusType = 'active' | 'revoked' | 'expired'

interface TypeAnimalTokenStatusProps {
  value?: {
    status: StatusType
    text: string
  } | null
}

export default function TypeAnimalTokenStatus({ value }: TypeAnimalTokenStatusProps) {
  if (!value || !value.status) return '-'

  const { status, text } = value

  const mapStatus: Record<StatusType, React.CSSProperties> = {
    active: Colors.feedback.success,
    expired: Colors.feedback.error,
    revoked: Colors.feedback.regular,
  }

  return <CowmedChip value={text} style={mapStatus[status]} />
}
